import React, { useState } from "react";

import styles from "./styles.module.scss";

const Notes = ({ notes, imageId, allImages, setImages }) => {
    const [textValue, setTextValue] = useState(notes);

    const handleChange = (event) => {
        event.preventDefault();

        setTextValue(event.target.value);
    };

    const handleBlur = (event) => {
        event.preventDefault();

        setImages(allImages.map((img) => (img.id === imageId ? { ...img, notes: event.target.value } : img)));
    };

    const maxLength = 100;

    return (
        <div className={styles.notesContainer}>
            <span className={styles.notesContainerTitle}>Notes</span>
            <textarea
                className={styles.notesTextarea}
                value={textValue}
                onChange={(event) => handleChange(event)}
                onBlur={(event) => handleBlur(event)}
                placeholder={"Add notes..."}
                maxLength={`${maxLength}`}
            />
            <span className={styles.notesCharCount}>{textValue.length}/{maxLength}</span>
        </div>
    );
};

export default Notes;
